import {title} from "assets/jss/material-kit-react.jsx";
import blueBG from "assets/img/blue_bg.png";

const tweetPollStyle = {
  section: {
    paddingTop: 100,
    paddingBottom: 50,
    backgroundImage: `url(${blueBG})`,
    backgroundPosition: "0px 0px",
    backgroundSize: 719,

    // backgroundImage: `url(${metaBG})`,
    height: 450,
    // backgroundPosition: "50% 100%",
    // backgroundSize: "contain",
    // backgroundRepeat: "no-repeat",
  },
  title: {
    ...title,
    marginTop: 30,
    marginBottom: 10,
    letterSpacing: 1,
    paddingLeft: 7,
    fontSize: 45,
    // lineHeight: 50,
    fontWeight: 400,
    textTransform: "none",
    textAlign: "left",
    color: "#707070",
  },
};

export default tweetPollStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/pollTemplateSections/tweetPollStyle.jsx